import { apiClient } from '../client';
import type { AdminPortalBff } from '@aaimplatform/institutional-types';

export type PipelineSummary = AdminPortalBff.components['schemas']['PipelineSummary'];
export const loanPipelineApi = {
  getSummary: async (): Promise<PipelineSummary> => {
    return apiClient.get<PipelineSummary>('/admin/pipeline/summary');
  },
};
